import type { CustomizationScope } from './CustomizationScope';

/**
 * Рівень налаштування за вибором і правами (прототип v4 cscope, чиста функція): без вибору — робочий простір, якщо дозволено, інакше
 * глобально; недозволений вибір виправляється на інший рівень, якщо той дозволено.
 */
export function resolveScope(chosen: CustomizationScope | null, canWs: boolean, canGlobal: boolean): CustomizationScope {
  let scope: CustomizationScope = chosen ?? (canWs ? 'ws' : 'global');
  if (scope === 'global' && !canGlobal) scope = 'ws';
  if (scope === 'ws' && !canWs && canGlobal) scope = 'global';
  return scope;
}
